export const topDrawerThemeToTailwindClasses = (theme: any) => {
    return [
        "top-bar",
        "border-shadow-2xl",
        "absolute",
        "right-0",
        "top-0",
        "z-[99999]",
        "flex",
        "w-full",
        "flex-col",
        "lg:flex-row",
        "items-center",
        "justify-center",
        "space-y-1",
        "border",
        "border-t",
        "border-gray-200",
        "bg-white",
        "p-2",
        "shadow-lg",
        "transition-all",
        "duration-700",
        "ease-in-out",
    ];
};
